/**
 * Simple block tool that renders a TikTok embed iframe.
 */
export class TikTokEmbedBlock {
  private _data: { videoId: string; url: string };
  private _wrapper: HTMLElement | null = null;

  static get toolbox() {
    return {
      title: 'TikTok Embed',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3L19 12L5 21V3Z"></path></svg>'
    };
  }

  constructor({ data }: any) {
    this._data = {
      videoId: data?.videoId || '',
      url: data?.url || '',
    };
  }

  render(): HTMLElement {
    this._wrapper = document.createElement('div');
    this._wrapper.classList.add('tiktok-embed-preview');
    this._wrapper.style.cssText = 'margin: 1rem 0; border-radius: 12px; overflow: hidden; max-width: 325px; height: 578px; padding: 10px; background: transparent;';

    if (this._data.videoId) {
      // Create thumbnail poster with click-to-play
      const poster = document.createElement('div');
      poster.style.cssText = `
        width: 325px;
        height: 578px;
        background: #000;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        background-size: cover;
        background-position: center;
      `;

      // Fetch thumbnail from TikTok oEmbed API
      fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(this._data.url)}`)
        .then(res => res.json())
        .then(data => {
          if (data.thumbnail_url) {
            poster.style.backgroundImage = `url(${data.thumbnail_url})`;
          }
        })
        .catch(() => {
          // Fallback to gradient if fetch fails
          poster.style.backgroundImage = 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)';
        });

      // Play button overlay
      const playButton = document.createElement('div');
      playButton.innerHTML = `
        <div style="
          width: 64px;
          height: 64px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(4px);
          border: 2px solid white;
        ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white" style="margin-left: 4px;">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
      `;
      playButton.style.cssText = 'position: relative; z-index: 2;';
      poster.appendChild(playButton);

      // Click handler to load embed
      poster.addEventListener('click', () => {
        if (!this._wrapper) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.tiktok.com/embed/v2/${this._data.videoId}`;
        iframe.style.cssText = 'width: 325px; height: 578px; border: none; border-radius: 12px;';
        iframe.allowFullscreen = true;
        iframe.setAttribute('allow', 'encrypted-media');
        // Allow clicks to pass through iframe edges
        iframe.style.pointerEvents = 'auto';
        this._wrapper.innerHTML = '';
        this._wrapper.appendChild(iframe);
      });

      this._wrapper.appendChild(poster);
    }

    return this._wrapper;
  }

  save() {
    return this._data;
  }

  validate(_savedData: any): boolean {
    return true;
  }
}
